import { useLanguage } from "@/i18n/LanguageContext";

export const BenefitCard = ({ icon: Icon, color, bg, title, desc, testId }) => {
  const { t } = useLanguage();
  return (
    <div data-testid={testId} className="flex flex-col gap-3">
      <div
        className="flex h-12 w-12 items-center justify-center rounded-2xl transition duration-300 hover:scale-105"
        style={{ backgroundColor: bg }}
      >
        <Icon className="h-6 w-6" style={{ color }} />
      </div>
      <div>
        <h3 className="text-sm font-bold text-slate-900">{t(title)}</h3>
        <p className="mt-1 text-sm leading-relaxed text-slate-500">{t(desc)}</p>
      </div>
    </div>
  );
};
